import{}from"../createConfig.js";export function getChainId(config){return config.state.chainId}